import { FontClass } from "@ui/types/enums/FontClass";
import { HeaderText } from "@ui/components/text/HeaderText";
import type { Props } from "@ui/components/text/HeaderText";

export function Header1(props: Omit<Props, "fontClass">) {
  return <HeaderText {...props} fontClass={FontClass.Header1} />;
}
